import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { FormControl, Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Form, Card, InputGroup } from 'react-bootstrap';

import ReactCountryFlag from "react-country-flag"
import carbonEodPricingInputs from './../json/carbonEodPricingInputs.json';

import { Tooltip } from 'react-tooltip';



var arrayYears = []

const timeChangeList = {}
const timeChanges = Object.keys(carbonEodPricingInputs[0].timeChange)
timeChanges.forEach((timeChange, index) => {
    timeChangeList[timeChange] = carbonEodPricingInputs[0].timeChange[timeChange].percentage;
    arrayYears.push(timeChange);
})

// Sorting an array in descending order
arrayYears.reverse();


function TimeChange(props) {
    // Setting original values (pick the prior day data from the DB or JSON file)
    const [state, setState] = useState({
        timeChange2028: carbonEodPricingInputs.map(object => object.timeChange[2028].percentage),
        timeChange2027: carbonEodPricingInputs.map(object => object.timeChange[2027].percentage),
        timeChange2026: carbonEodPricingInputs.map(object => object.timeChange[2026].percentage),
        timeChange2025: carbonEodPricingInputs.map(object => object.timeChange[2025].percentage),
        timeChange2024: carbonEodPricingInputs.map(object => object.timeChange[2024].percentage),
        timeChange2023: carbonEodPricingInputs.map(object => object.timeChange[2023].percentage)
    })

    // Show or hide card based on onClick event
    const [hidden, setHidden] = useState(true);

    const handleChange = evt => {
        const name = evt.target.name;
        const value =
            evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
        setState({
            ...state,
            [name]: value
        })

        // Passing all values to parent class
        //props["jsonResponseRegistry"]({ "name": name, "value": value });
        props["jsonResponseTimeChange"]({ "name": name, "value": value });
    }


    return (
        <>
            <Card border="none" className="Card">
                <Card.Header className="Card-Header" style={{ cursor: 'pointer' }} onClick={() => setHidden(s => !s)}>&nbsp;Futures market</Card.Header>
                {!hidden ? null :

                    <Card.Body className="Card-Body">

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    2028
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="timeChange2028" value={state.timeChange2028} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="128" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)" }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    2027
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="timeChange2027" value={state.timeChange2027} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="128" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)" }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    2026
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="timeChange2026" value={state.timeChange2026} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="128" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)" }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    2025
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="timeChange2025" value={state.timeChange2025} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="128" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)", cursor: 'not-allowed' }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    2024
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="timeChange2024" value={state.timeChange2024} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="128" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)", cursor: 'not-allowed' }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                        <div class="input-group flex-nowrap">
                            <div style={{ width: 70, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">
                                    2023
                                </InputGroup>
                            </div>
                            <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input justified-content-center">
                                    <FormControl name="timeChange2023" value={state.timeChange2023} onChange={handleChange} aria-label="Small" type="number" step="1" placeholder="128" aria-describedby="inputGroup-sizing-sm" style={{ fontsize: "var(--module-font-size)", cursor: 'not-allowed' }} />
                                    <InputGroup.Text id="basic-addon2" style={{ fontsize: "var(--module-font-size)" }}>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                        </div>

                    </Card.Body >
                }
            </Card >

        </>
    );

}


export default TimeChange;